import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../05_redux/store';
import { Col, Row } from 'react-onsenui';
import classes from './PostDetail.module.scss';
import Wave from '../01_atoms/Wave';
import TopBar from '../01_atoms/TopBar';
import { PostEntity } from '../06_utils/db/entity/postEntity';

const PostDetail = () =>{
    const navigate = useNavigate();
    const posts:PostEntity[] = useSelector((root:RootState)=>root.postSlice.postStore.posts);
    const { id } = useParams();

    const post = posts.find(p=>p.id === Number(id));

    const back = () =>{
        navigate('/');
    }
    
    return(
        <>
            <TopBar fun={back} title={''}/> 
            <Wave invert/>
            <div className={classes.PostDetail}>
                <Row>
                    <Col className={classes.PostDetailDescr}>
                        {post?.comment}
                        dupa
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default PostDetail;